<template>
    <div>
        <b-modal :hideHeaderClose="true"  no-close-on-esc no-close-on-backdrop @ok="closeModal"  @cancel="closeModal" id="modal-CuentaDetalle" size="xl" title="Información Cuenta">
            <b-row>
                <b-col xl="12" lg="12" md="12" sm="12">
                    <b-overlay :show="loadingCuenta" rounded="sm">
                        <b-card border-variant="primary" class="my-1" align="left">
                            <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4">
                                <b-col class="my-1">
                                    <b-button block size="sm" variant="primary" class="h-100"
                                        @click="closeModal()"><b-icon-x></b-icon-x> CERRAR
                                        {{ helpKeys ? "(ESC)" : "" }}</b-button>
                                </b-col>
                                <b-col class="my-1">
                                    <b-button block size="sm" variant="primary" class="h-100"
                                        @click="queryActualTicket">ACTUALIZAR
                                    </b-button>
                                </b-col>
                                <b-col class="my-1">
                                    <b-button block size="sm" variant="primary" class="h-100"
                                        @click="reUploadTicket">REENVIAR
                                    </b-button>
                                </b-col>
                                <b-col class="my-1" v-if="puedeAsignarCliente">
                                    <b-button block size="sm" variant="success" class="h-100"
                                        @click="abrirAsignarCliente"><b-icon-person-plus></b-icon-person-plus> ASIGNAR CLIENTE
                                    </b-button>
                                </b-col>
                                <b-col class="my-1" v-if="puedeReprocesarLealtad">
                                    <b-button block size="sm" variant="info" class="h-100" :disabled="reprocesandoLealtad"
                                        @click="reprocesarLealtad"><b-icon-arrow-repeat></b-icon-arrow-repeat> REPROCESAR LEALTAD
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-alert class="my-1" variant="success" show v-if="actualCuenta.discount_type_id != 1">Descuento
                            Aplicado:{{ actualCuenta.discount_type.name }} ({{
            actualCuenta.discount_percentage
        }}%)
                        </b-alert>
                        <b-alert class="my-1" variant="danger" show v-if="actualCuenta.canceled">Cuenta Cancelada
                        </b-alert>
                        <b-alert class="my-1" :variant="variantLealtad" show v-if="resultadoLealtad" dismissible
                            @dismissed="resultadoLealtad = null">
                            Lealtad: <b>{{ resultadoLealtad.status }}</b>
                            <span v-if="resultadoLealtad.reason"> ({{ resultadoLealtad.reason }})</span>
                            <span v-if="resultadoLealtad.status === 'processed'"> · {{ resultadoLealtad.points_earned }} puntos</span>
                            <span v-if="resultadoLealtad.error"> · {{ resultadoLealtad.error }}</span>
                            <div v-if="resultadoLealtad.detail" class="small text-monospace">{{ resultadoLealtad.detail }}</div>
                        </b-alert>
                        <b-card no-body border-variant="primary" class="my-1 p-3">
                            <b-row cols-xl="3" cols-lg="3" cols-md="2" cols="1">
                                <b-col>
                                    <p class="my-0">
                                        Sucursal: {{ actualCuenta.sucursal.nombre }}<br>
                                        ID Sistema: {{ actualCuenta.id }}<br>
                                        Mesa: {{ actualCuenta.table_no }}<br>
                                        Tipo: {{ actualCuenta.restaurant_area.name }}<br>
                                        Mesero: {{actualCuenta.waiter_complete.id+" "+actualCuenta.waiter_complete.name }}<br>
                                        Personas: {{ actualCuenta.persons }}<br>
                                        Cliente: {{ actualCuenta.customer_name || (actualCuenta.customer_id ? 'ID ' + actualCuenta.customer_id : 'Sin cliente') }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="my-0">
                                        Folio: {{ actualCuenta.numticket }}<br>
                                        Apertura: {{ actualCuenta.date_open }}<br>
                                        Cierre: {{ actualCuenta.date_close }}<br>
                                        Impresa: <b-icon-check-circle-fill v-if="actualCuenta.printed"
                                            variant="success"></b-icon-check-circle-fill><b-icon-x-circle-fill v-else
                                            variant="danger"></b-icon-x-circle-fill>
                                        Pagada: <b-icon-check-circle-fill v-if="actualCuenta.paid"
                                            variant="success"></b-icon-check-circle-fill><b-icon-x-circle-fill v-else
                                            variant="danger"></b-icon-x-circle-fill>
                                        Cancelada: <b-icon-check-circle-fill v-if="actualCuenta.canceled"
                                            variant="success"></b-icon-check-circle-fill><b-icon-x-circle-fill v-else
                                            variant="danger"></b-icon-x-circle-fill>
                                        Propina: $ {{ actualCuenta.tip }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="my-0">
                                        Turno: {{ actualCuenta.shift_id }}<br>
                                        Subtotal: $ {{ actualCuenta.total }}<br>
                                        Descuentos: $ {{ actualCuenta.discount_amount }}<br>
                                        Total: $ {{ actualCuenta.total_with_discount }}<br>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <p class="my-0">Comentario: {{ actualCuenta.comment }}</p>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card v-if="actualCuenta.delivery_company != null" title="Delivery" border-variant="primary"
                            class="my-1 h-100">
                            <b-row>
                                <b-col>
                                    <p class="my-0">
                                        Canal: {{ actualCuenta.delivery_company }}<br>
                                        ID: {{ actualCuenta.delivery_id }}<br>
                                        Status: {{ actualCuenta.delivery_status }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="my-0">
                                        Pago: {{ actualCuenta.delivery_payment }}<br>
                                        Tipo: {{ actualCuenta.delivery_type }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="my-0">
                                    </p>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card title="Productos" border-variant="primary" class="my-1 h-100">
                            <b-row>
                                <b-col>
                                    <b-table small  striped hover responsive sticky-header="90vh"
                                        :items="actualCuenta.ticket_products" :fields="actualCuentaFields">
                                        <template #cell(cancelled)="data">
                                            <div v-if="data.item.cancelled">
                                                <b-icon icon="dash-circle-fill" variant="danger"></b-icon> Cancelado
                                            </div>

                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card title="Pagos" border-variant="primary" class="my-3 h-100">
                            <b-row>
                                <b-col>
                                    <b-table small striped hover filter="true" responsive sticky-header="90vh"
                                        :items="actualCuenta.payments" :fields="paymentFields">

                                        <template #cell(buttons)="data">
                                            <b-dropdown text="Mas" variant="primary" size="sm">
                                                <b-dropdown-item :disabled="!data.item.status"
                                                    @click="sendCancelPayment(data.item.id)">Cancelar</b-dropdown-item>
                                            </b-dropdown>
                                        </template>
                                        <template #cell(status)="data">
                                            <div v-if="!data.item.status">
                                                <b-icon icon="x-circle-fill" variant="danger"></b-icon> Cancelado
                                            </div>
                                            <div v-if="data.item.status">
                                                <b-icon icon="check-circle-fill" variant="success"></b-icon> Activo
                                            </div>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-card>
                        <FacturarTicket :ticket="actualCuenta" @invoiced="onInvoiced"></FacturarTicket>
                        <b-card title="Log" border-variant="primary" class="my-1 h-100">
                            <b-row>
                                <b-col>
                                    <b-table class="h-100" small striped hover :items="log"
                                        :fields="logFields">
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-overlay>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modal-AsignarCliente" size="lg" title="Asignar cliente a la cuenta" hide-footer
            @shown="$refs.busquedaCliente.focus()">
            <p class="small text-muted">
                Folio {{ actualCuenta.numticket }} · {{ actualCuenta.sucursal.nombre }} · Total $ {{ actualCuenta.total_with_discount }}.
                Al asignar el cliente se acreditan los puntos de lealtad que correspondan. Ya no se puede cambiar después.
            </p>
            <b-input-group prepend="Buscar:">
                <b-form-input ref="busquedaCliente" v-model="busquedaCliente" debounce="400"
                    placeholder="Nombre, teléfono, correo o código"></b-form-input>
            </b-input-group>
            <b-overlay :show="buscandoClientes || asignandoCliente" rounded="sm">
                <b-table class="mt-2" small hover responsive :items="clientesEncontrados" :fields="clienteFields"
                    show-empty :empty-text="busquedaCliente.trim().length < 3 ? 'Escribe al menos 3 caracteres' : 'Sin resultados'">
                    <template #cell(acciones)="data">
                        <b-button size="sm" variant="success" :disabled="asignandoCliente"
                            @click="asignarCliente(data.item)">Asignar</b-button>
                    </template>
                </b-table>
            </b-overlay>
        </b-modal>
    </div>
</template>
<script>
import axios from "axios";
import FacturarTicket from "./FacturarTicket.vue";
import customersService from "../services/customersService";
export default {
    name: "CuentaDetalle",
    components: { FacturarTicket },
    props: ["ticket_id"],
    data: () => {
        return {
            log: [],
            logFields: [
                { key: "action_id", label: "ID" },
                { key: "action_date", label: "Fecha" },
                { key: "description", label: "Descripcion" },
            ],
            loadingCuenta: false,
            paymentFields: [
                { key: "id", label: "ID" },
                { key: "payment_method.name", label: "Metodo de pago" },
                { key: "payment_amount", label: "Monto" },
                { key: "tip_amount", label: "Propina" },
                { key: "status", label: "Status" },
                { key: "buttons", label: "" }
            ],
            actualCuentaFields: [
                { key: "movement", label: "Mov" },
                { key: "quantity", label: "Cant" },
                { key: "product_code", label: "Clave" },
                { key: "cancelled", label: "Canc." },
                { key: "product.ndescription", label: "Descripcion" },
                { key: "discount_percentage", label: "Descuento" },
                { key: "price", label: "Precio" },
                { key: "total_with_discount", label: "Total" },
            ],
            actualCuenta: {
                ticket_products: [],
                restaurant_area: {
                    name: "",
                },
                discount_type: {
                    name: "",
                },
                sucursal: {
                    nombre: "",
                },
                waiter_complete: {
                    name: "",
                },
            },
            activeTicketId: 0,
            busquedaCliente: "",
            clientesEncontrados: [],
            buscandoClientes: false,
            asignandoCliente: false,
            reprocesandoLealtad: false,
            // Resultado del motor de lealtad de la última asignación/reproceso.
            resultadoLealtad: null,
            clienteFields: [
                { key: "id", label: "ID" },
                { key: "name", label: "Nombre" },
                { key: "phone", label: "Teléfono" },
                { key: "email", label: "Correo" },
                { key: "acciones", label: "" },
            ],
        };
    },
    computed: {
        activeTicket() {
            return this.$store.getters["api/activeTicket"];
        },
        imgLink() {
            return this.$store.getters["api/imgLink"];
        },
        products() {
            return this.$store.getters["api/allProducts"];
        },
        activeTickets() {
            return this.$store.getters["api/allActiveTickets"];
        },
        restAreas() {
            return this.$store.getters["api/allRestAreas"];
        },
        printed() {
            return this.actualCuenta.printed == 1;
        },
        // Solo cuentas sin cliente y no canceladas: reasignar implicaría revertir
        // puntos de otra persona, así que el backend tampoco lo permite.
        puedeReprocesarLealtad() {
            return this.hasPermission("rrn:central:tickets:assignCustomer") &&
                this.actualCuenta.sid > 0 && this.actualCuenta.loyalty_status !== "processed";
        },
        variantLealtad() {
            let st = this.resultadoLealtad && this.resultadoLealtad.status;
            if (st === "processed") return "success";
            if (st === "error") return "danger";
            return "warning";
        },
        puedeAsignarCliente() {
            return this.hasPermission("rrn:central:tickets:assignCustomer") &&
                this.actualCuenta.sid > 0 && !this.actualCuenta.customer_id && !this.actualCuenta.canceled;
        },
    },
    mounted() {
       
    },
    watch: {
        busquedaCliente(n) {
            this.buscarClientes(n);
        },
        ticket_id(n) {
            if (n > 0) {
                this.activeTicketId=n
                this.openModal()
            }
        }
    },
    methods: {
        openModal() {
            this.$bvModal.show("modal-CuentaDetalle")
            this.changeActualTicket(this.activeTicketId)
        },
        closeModal() {
            this.$bvModal.hide("modal-CuentaDetalle")
            this.activeTicketId = 0;
            this.$emit('changeTicketId',0)
        },
        changeActualTicket(ntick) {
            console.log(ntick);
            this.resultadoLealtad = null;
            this.activeTicketId = ntick;
            this.queryActualTicket();
        },
        reUploadTicket() {
            let that = this
            axios
                .post("/sucursal/" + that.actualCuenta.sucursal_id + "/action/reUploadTicket", this.actualCuenta.id)
                .then(function (response) {
                    console.log(response.data)
                    that.loadingCuenta = false;
                    that.makeToast("success", "Exito", "La cuenta se actualizara en algunos minutos");
                })
                .catch(function (r) {
                    that.loadingCuenta = false;
                    that.makeToast("danger", "Error", r.response.data);
                });
        },
        sendCancelPayment(id) {
            let that = this
            axios
                .post("/sucursal/" + that.actualCuenta.sucursal_id + "/action/cancelTicketPayment", id)
                .then(function (response) {
                    console.log(response.data)
                    that.loadingCuenta = false;
                    that.makeToast("success", "Exito", "La cuenta se actualizara en algunos minutos");
                })
                .catch(function (r) {
                    that.loadingCuenta = false;
                    that.makeToast("danger", "Error", r.response.data);
                });
        },
        queryActualTicket() {
            this.loadingCuenta = true;
            let that = this;
            axios
                .get("/ticket/sid/" + this.activeTicketId)
                .then(function (response) {
                    that.actualCuenta = response.data;
                    that.loadingCuenta = false;
                })
                .catch(function (r) {
                    that.loadingCuenta = false;
                    that.makeToast("danger", "Error", r.response.data);
                });
        },
        getActiveTicket: function (row) {
            this.activeTicketId = row.sid;
            this.queryActualTicket();
        },
        abrirAsignarCliente() {
            this.busquedaCliente = "";
            this.clientesEncontrados = [];
            this.$bvModal.show("modal-AsignarCliente");
        },
        buscarClientes(term) {
            term = (term || "").trim();
            if (term.length < 3) {
                this.clientesEncontrados = [];
                return;
            }
            this.buscandoClientes = true;
            let that = this;
            customersService
                .search({ q: term, limit: 20 })
                .then(function (response) {
                    // Descarta respuestas de una búsqueda que ya cambió.
                    if (term !== that.busquedaCliente.trim()) return;
                    that.clientesEncontrados = (response.data && response.data.customers) || [];
                })
                .catch(function (r) {
                    that.makeToast("danger", "Error", r.response ? r.response.data : String(r));
                })
                .finally(function () {
                    that.buscandoClientes = false;
                });
        },
        asignarCliente(cliente) {
            this.asignandoCliente = true;
            let that = this;
            axios
                .put("/ticket/sid/" + this.actualCuenta.sid + "/customer", { customer_id: cliente.id })
                .then(function (response) {
                    that.actualCuenta = response.data.ticket;
                    that.resultadoLealtad = response.data.loyalty;
                    that.$bvModal.hide("modal-AsignarCliente");
                    that.makeToast("success", "Cliente asignado", "La cuenta quedó asignada a " + cliente.name);
                    that.$emit("customerAssigned", response.data.ticket);
                })
                .catch(function (r) {
                    that.makeToast("danger", "Error", r.response ? r.response.data : String(r));
                })
                .finally(function () {
                    that.asignandoCliente = false;
                });
        },
        reprocesarLealtad() {
            this.reprocesandoLealtad = true;
            let that = this;
            axios
                .put("/ticket/sid/" + this.actualCuenta.sid + "/loyalty/reprocess")
                .then(function (response) {
                    that.actualCuenta = response.data.ticket;
                    that.resultadoLealtad = response.data.loyalty;
                })
                .catch(function (r) {
                    that.makeToast("danger", "Error", r.response ? r.response.data : String(r));
                })
                .finally(function () {
                    that.reprocesandoLealtad = false;
                });
        },
        // Se propaga para que el listado repinte el badge sin volver a consultar
        // todas las cuentas.
        onInvoiced(ticketSid) {
            this.$emit("invoiced", ticketSid);
        },
        makeToast(variant = null, title = "", text = "") {
            this.$bvToast.toast(text, {
                title: title,
                variant: variant,
                solid: true,
                appendToast: true,
            });
        }
    }
}
</script>